/**
 * Indian customers pay through Razorpay, not Stripe.
 *
 * The checkout screens list a gateway per currency, and until now INR offered both: Stripe (through the
 * separate Indian Stripe account) and Razorpay, with Stripe preselected as "recommended". India's plans and
 * top-ups are meant to go through Razorpay, so for INR the Stripe option is removed and Razorpay is what is
 * left to default to. Every other currency is untouched.
 *
 * If Razorpay is not enabled there is no INR gateway at all, and that is deliberate: it is better for an
 * Indian customer to see "not available yet" than to be quietly charged through the wrong account. The
 * screens turn that empty list into a message.
 *
 * Shared so the plan modal, the Upgrade page and the top-up dialog cannot drift apart.
 */

export type BillingGateway = "stripe" | "razorpay" | "paypal" | "paystack" | "mercadopago";

export const INDIA_CURRENCY = "INR";

export function isIndianPlan(plan: { country?: string | null } | null | undefined): boolean {
  return (plan?.country ?? "").toUpperCase() === "IN";
}

/** The gateways a customer may choose between for `currency`. */
export function gatewaysForCurrency<G extends string>(currency: string, gateways: readonly G[]): G[] {
  if (currency.toUpperCase() !== INDIA_CURRENCY) return [...gateways];
  return gateways.filter((g) => g !== "stripe");
}
